import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BreadcrumbsComponentDef } from '@df/ui/common/breadcrumbs.component.def';
/**
 * Breadcrumbs component
 *
 * ## usage
 *
 * <breadcrumbs></breadcrumbs>
 */
@Component({
    selector: 'breadcrumbs',
    templateUrl: './breadcrumbs.html',
    styleUrls: ['./breadcrumbs.scss'],
    standalone: true,
    imports: [RouterLink],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BreadcrumbsComponent extends BreadcrumbsComponentDef {}
